import {
  QueryKey,
  UseInfiniteQueryOptions as ReactQueryUseInfiniteQueryOptions,
  UseQueryOptions as ReactQueryUseQueryOptions,
  UseQueryResult as ReactQueryUseQueryResult,
  UseMutationOptions as ReactQueryUseMutationOptions,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ApiError } from '@arrived/models';

// TODO: I do not think this is the right type; it should just be AxiosError
export type QueryError = AxiosError & ApiError;

/**
 * Create new defaults for the `Use[Query]` results. This
 * allows us to have the Axios error typed into the our hooks.
 */

export type UseQueryOptions<
  TQueryFnData = unknown,
  TQueryKey extends QueryKey = QueryKey,
  TError = QueryError | undefined,
  TData = TQueryFnData
> = ReactQueryUseQueryOptions<TQueryFnData, TError, TData, TQueryKey>;

export type UseInfiniteQueryOptions<
  TQueryFnData = unknown,
  TQueryKey extends QueryKey = QueryKey,
  TError = QueryError | undefined,
  TData = TQueryFnData,
  TQueryData = TQueryFnData
> = ReactQueryUseInfiniteQueryOptions<TQueryFnData, TError, TData, TQueryFnData, TQueryKey>;

export type UseQueryResult<TData = unknown, TError = QueryError | undefined> = ReactQueryUseQueryResult<TData, TError>;

export type UseMutationOptions<
  TData = unknown,
  TVariables = undefined,
  TContext = undefined,
  TError = QueryError | undefined
> = ReactQueryUseMutationOptions<TData, TError, TVariables, TContext>;

/**
 * Instead of using INFINITY, we'll use this as the maximum stale time for our queries (milliseconds).
 */
export const MAX_STALE_TIME = 600_000;
